import React, { ReactNode } from 'react';
import { Pagination } from 'antd';
import { PaginationProps as PaginationCopyProps } from 'antd/lib/pagination';

export type PaginationProps = PaginationCopyProps & {
  children?: ReactNode;
};

const ProPagination: React.FC<PaginationProps> = props => {
  const { children, ...resProps } = props;

  return <Pagination {...resProps}>{children}</Pagination>;
};

export default ProPagination;
